import { ReactNode } from 'react'

type InputIndicatorProps = {
  theme: 'error' | 'warning'
  before?: ReactNode
  after?: ReactNode
}

const InputIndicator = ({ theme, before, after }: InputIndicatorProps) => {
  const bgColor = theme === 'error' ? 'bg-error' : 'bg-alert'

  return (
    <div className="flex gap-1 items-center">
      {before}
      <div
        className={`flex items-center justify-center rounded-xl w-3 h-3 font-bold text-white ${bgColor}`}
      >
        !
      </div>
      {after}
    </div>
  )
}

export default InputIndicator
